module.exports = __webpack_public_path__ + "static/media/F10-Express_js.0f915fac.svg";